/** Id lookups over a (never mutated) galaxy, built once per galaxy object and cached. */
import type { Galaxy, Relay, StarSystem } from '../../galaxy/types'

export interface GalaxyIndex {
  readonly systems: ReadonlyMap<string, StarSystem>
  readonly relays: ReadonlyMap<string, Relay>
}

const cache = new WeakMap<Galaxy, GalaxyIndex>()

export function galaxyIndex(galaxy: Galaxy): GalaxyIndex {
  let index = cache.get(galaxy)
  if (!index) {
    index = {
      systems: new Map(galaxy.systems.map((s) => [s.id, s])),
      relays: new Map(galaxy.relays.map((r) => [r.id, r])),
    }
    cache.set(galaxy, index)
  }
  return index
}

/** The system at the other end of `relay` from `systemId`. */
export function farEnd(relay: Relay, systemId: string): string {
  return relay.a === systemId ? relay.b : relay.a
}
